import {Injectable} from '@angular/core';
import {BaseRestService} from './base-rest.service';
import {AppSettingsService} from './app-settings.service';
import {HttpClient} from '@angular/common/http';
import {Client, EMPTY_GUID, SendBackResult} from '..';
import {Observable} from 'rxjs';
import { map, skipWhile} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import * as fromOrder from '../../order/reducers';
import {Order} from '../../order/models/order';
import * as fromContracts from '../../contract/reducers';
import {Contract} from '../../contract/models/contract';

@Injectable({
  providedIn: 'root'
})
export class DuplicateService extends BaseRestService {

  clientUuid: string;
  siteUuid: string;
  contractUuid: string;

  constructor(http: HttpClient, appSettingsService: AppSettingsService,
              private store: Store<fromOrder.AppState>,
              private storeContract: Store<fromContracts.AppState>) {
    super(http, appSettingsService);
    this.store.pipe(
        select(fromRoot.selectors.getCurrentClient),
        skipWhile((data: Client) => !data),
        map((client: Client) => client.uuid)
      ).subscribe( (uuid: string) => { this.clientUuid = uuid; } );

    this.storeContract.pipe(
      select(fromContracts.selectors.getCurrentContract),
      skipWhile((data: Client) => !data),
      map((contract: Contract) => contract)
    ).subscribe( (contract: Contract) => {
      if (contract) {
        this.contractUuid = contract.uuid;
      } else {
        this.contractUuid = null;
      }
    });

    this.store.pipe(
        select(fromOrder.selectors.getOrder),
        skipWhile((data) => data === null),
        map((order: Order) => order ? order.site.uuid : order )
      ).subscribe( (uuid: string) => {
        if (uuid) {
          this.siteUuid = uuid; // TODO: why skipWhile not working here
        }
    } );
  }

  protected get className(): string {
    return 'DuplicateService';
  }

  protected get isAnonymous(): boolean {
    return false;
  }

  /*
  * used in dynamic component
  * in parallel with validators for footer
  * */
  duplicate(config: string[], name: string , type?: string): Observable<boolean> {
    if (config[0] === 'clientName') {
      return this.clientName(name).pipe(
        map(response => response.data['value'])
      )
    } else if (config[0] === 'siteName') {
      return this.siteName(this.clientUuid, name, this.siteUuid).pipe(
        map(response => response.data['value'])
      )
    } else if (config[0] === 'subscriptionName') {
      return this.subscriptionName(this.clientUuid, config[2], name).pipe(
        map(response => response.data['value'])
      )
    } else if (config[0] === 'contractName') {
      if (type === 'duplication') {
        return this.contractName(name ,   null).pipe(
          map(response => response.data['value'])
        )
      } else {
        return this.contractName(name ,   this.contractUuid).pipe(
          map(response => response.data['value'])
        )
      }
    }
  }

  clientName(name: string): Observable<SendBackResult<boolean>> {
    return this.post<boolean>(`/clients/exists`, {name: name})
  }

  contractName(name: string ,  contractUuid?: string): Observable<SendBackResult<boolean>> {
    if (contractUuid) {
      return this.post<boolean>(`/Contract/Exists`, {name: name, uuid: contractUuid })
    } else {
      return this.post<boolean>(`/Contract/Exists`, {name: name})
    }

  }

  siteName(clientUuid: string, name: string, siteUuid?: string): Observable<SendBackResult<boolean>> {
    if (!siteUuid) {
      siteUuid = EMPTY_GUID
    }
    return this.post<boolean>(`/clients/${clientUuid}/sites/${siteUuid}/exists`, {name: name});
  }

  subscriptionName(clientUuid: string, siteUuid: string, name: string): Observable<SendBackResult<boolean>> {
    return this.post<boolean>(`/clients/${clientUuid}/sites/${siteUuid}/subscriptions/exists`, {name: name});
  }
}
